module.exports = __webpack_public_path__ + "img/jm.e62b1514.jpg";